<template>
  <v-container>
    <h1>Help</h1>
    <p>Just type stuff or whatever, ok?</p>
  </v-container>
</template>

<script>
export default {
  name: "Help"
};
</script>
